<template>
  <div style="padding: 20px">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺别名">
                  <!-- <el-select v-model="form.vendorId" filterable>
                    <el-option
                      v-for="(item, idx) in vendorList"
                      :key="idx"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select> -->
                  <BrandSelect :data="vendorList" v-model="form.vendorId" filterable clearable></BrandSelect>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button type="primary" size="small" @click.stop="query"
              >查询</el-button
            >
            <el-button size="small" @click.stop="resetQuery">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-table class="myTable" :data="tableData">
      <el-table-column prop="vendorName" label="买手店名称"></el-table-column>
      <el-table-column prop="country" label="国家"></el-table-column>
      <el-table-column prop="vendorType" label="店铺类型"></el-table-column>
      <el-table-column prop="supplyPriceDesc" label="价格接入方式"></el-table-column>
      <el-table-column prop="businessArea" label="业务区域"></el-table-column>
      <el-table-column label="操作" width="200" prop="">
        <template slot-scope="scope">
          <el-button type="text" @click="setting(scope.row)">设置</el-button>
          <Dropdown
            :transfer="true"
            trigger="custom"
            :visible="scope.row.visible"
            placement="bottom-start"
            style="margin-left: 20px"
          >
            <el-button
              v-btnAuth="{ menuCode: 'daily-discount', btnCode: '复制-买手店' }"
              v-if="scope.row.parentFlag"
              @click="getDiscountStatus(scope.row)"
              type="text"
              >复制</el-button
            >
            <DropdownMenu slot="list">
              <div class="dropdown-item" @click="showDialog(scope.row, 1)">
                复制待生效折扣
              </div>
              <div class="dropdown-item" @click="showDialog(scope.row, 2)">
                复制已生效折扣
              </div>
            </DropdownMenu>
          </Dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 20px 0; padding-bottom: 20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 25, 30, 50]"
      :page-size="pageSize"
      layout="total, prev, pager, next,sizes, jumper"
      :total="total"
    ></el-pagination>
    <el-dialog
      title="复制"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div class="dialogContainer">
        <p style="margin: 20px 0">
          <el-button
            size="small"
            type="primary"
            @click="selectVendorList = vendorLists.map((item) => item.vendorId)"
            >选择所有店铺</el-button
          >
          <el-button size="small" type="success" @click="selectVendorList = []"
            >取消全部</el-button
          >
        </p>
        <el-checkbox-group v-model="selectVendorList">
          <el-checkbox
            v-for="(item, index) in vendorLists"
            :key="index"
            :label="item.vendorId"
            >{{ item.vendorName }}</el-checkbox
          >
        </el-checkbox-group>
        <p style="margin: 20px 0">
          <el-button size="small" type="primary" @click="selectAllSeason">{{
            dialogDiscountStatus === 1
              ? "选择所有待生效折扣"
              : "选择所有已生效折扣"
          }}</el-button>
          <el-button
            size="small"
            type="success"
            @click="
              selectDiscountListAdult = [];
              selectDiscountListKids = [];
            "
            >取消全部</el-button
          >
        </p>
        <p v-if="discountListsAdult.length" style="margin: 20px 0">Adult</p>
        <el-checkbox-group v-model="selectDiscountListAdult">
          <el-checkbox
            v-for="(item, index) in discountListsAdult"
            :key="index"
            :label="item.value"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <p v-if="discountListsKids.length" style="margin: 20px 0">Kids</p>
        <el-checkbox-group v-model="selectDiscountListKids">
          <el-checkbox
            v-for="(item, index) in discountListsKids"
            :key="index"
            :label="item.value"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <el-form
          :model="ruleForm2"
          ref="ruleForm2"
          :rules="rules2"
          label-width="140px"
          label-position="left"
          class="demo-ruleForm"
        >
          <el-form-item label="生效时间：" prop="validFromType">
            <el-radio-group
              v-model="ruleForm2.validFromType"
              class="flex"
              @change="changeValidFromType"
            >
              <el-radio label="0">指定时间生效</el-radio>
              <el-radio label="1">立即生效</el-radio>
              <el-radio label="2" v-if="dialogDiscountStatus === 1"
                >沿用折扣当前的生效时间</el-radio
              >
            </el-radio-group>
            <el-date-picker
              class="absolute"
              :disabled="
                ruleForm2.validFromType == 1 || ruleForm2.validFromType == 2
              "
              v-model="ruleForm2.validFrom"
              :picker-options="option"
              type="datetime"
              @change="handle(2)"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="失效时间：" prop="nextValidDateType">
            <el-radio-group v-model="ruleForm2.nextValidDateType" class="flex">
              <el-radio
                label="0"
                :disabled="ruleForm2.validFromType == 2 ? true : false"
                >指定时间失效</el-radio
              >
              <el-radio label="1">无失效时间</el-radio>
              <el-radio
                label="2"
                v-if="dialogDiscountStatus === 1"
                :disabled="ruleForm2.validFromType == 2 ? false : true"
                >沿用折扣当前的失效时间(可能无)</el-radio
              >
            </el-radio-group>
            <el-date-picker
              class="absolute"
              :disabled="
                ruleForm2.nextValidDateType == 1 ||
                ruleForm2.nextValidDateType == 2
              "
              v-model="ruleForm2.nextValidDate"
              type="datetime"
              placeholder="选择失效时间"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils/util";
import {
  getDiscountVendorList,
  getVendorsByVendorName,
  priceChangeRuleCopy,
  discountStatus,
  discountStatusSeason,
  priceChangeRuleCopyCheck,
} from "../api.js";
import BrandSelect from '@/views/components/brandSelect.vue';

export default {
  data() {
    return {
      vendorList: [],
      cities: [],
      activityName: "",
      form: {
        vendorId: "",
      },
      currentPage: 1,
      pageSize: 15,
      total: 0,
      ruleForm2: {
        validFromType: null,
        validFrom: null,
        nextValidDate: null,
        nextValidDateType: null,
      },
      rules2: {
        validFromType: [
          { required: true, message: "请选择生效时间", trigger: "change" },
        ],
        nextValidDateType: [
          { required: true, message: "请选择失效时间", trigger: "change" },
        ],
      },
      option: {
        disabledDate: (val) => {
          return val.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },
      dialogDiscountStatus: "",
      dialogVisible: false,
      tableData: [],
      vendorLists: [],
      selectVendorList: [],
      discountListsAdult: [],
      discountListsKids: [],
      selectDiscountListAdult: [],
      selectDiscountListKids: [],
    };
  },
  components: {BrandSelect},
  created() {
    getVendorsByVendorName({ vendorId: "" }).then((res) => {
      this.vendorList = (res.data || []).map((item) => {
        return {
          label: item.vendorName,
          value: item.vendorId,
        };
      });
    });
    this.query();
  },
  methods: {
    changeValidFromType(val) {
      this.$nextTick(() => {
        if (val == 2 && this.ruleForm2.nextValidDateType == 0) {
          this.ruleForm2.nextValidDateType = null;
        }
        if ((val == 0 || val == 1) && this.ruleForm2.nextValidDateType == 2) {
          this.ruleForm2.nextValidDateType = null;
        }
      });
    },
    query() {
      this.currentPage = 1;
      this.getTableData();
    },
    resetQuery() {
      this.form.vendorId = "";
      this.currentPage = 1;
      this.getTableData();
    },
    handle(num) {
      let startAt = (new Date(this[`ruleForm${num}`].validFrom) * 1000) / 1000;
      if (startAt < Date.now()) {
        this[`ruleForm${num}`].validFrom = new Date();
      }
    },
    getDiscountStatus(row) {
      // 初始化Dropdown状态
      this.tableData.forEach((item) => {
        item.visible = false;
      });

      discountStatus(row.vendorId)
        .then((res) => {
          if (res.data && res.data.success) {
            const { state } = res.data.data;
            switch (state) {
              case 1: // 只存在待生效的
              case 2: // 只存在已生效的
                this.showDialog(row, state);
                break;
              case 3: // 同时存在两种状态
                row.visible = true;
                break;
              case 4: // 没有配置任何规则
                this.$message.error("当前无任何折扣可以复制");
                break;
            }
            return;
          }
          throw Error();
        })
        .catch((err) => {
          this.$message.error("请求异常");
        });
    },
    async showDialog(data, status) {
      // 初始化Dropdown状态
      this.tableData.forEach((item) => {
        item.visible = false;
      });

      try {
        Promise.all([
          getVendorsByVendorName({ parentId: data.vendorId }),
          discountStatusSeason(data.vendorId, status),
        ])
          .then((res) => {
            if (res && res[0] && res[0].data) {
              //获取子店铺列表
              const vendorLists = res[0].data;
              this.vendorLists = vendorLists;
            }
            if (res && res[1]) {
              //待生效季节及时间
              const { adult, kids } = res[1].data.data;
              this.discountListsAdult = (adult || []).map((item) => {
                let showLabel = item.seasonCode;
                if (item.coFlag === 1) {
                  showLabel += "(CO)";
                }
                if (status === 1) {
                  showLabel += `（${utils.dateFormat(
                    new Date(item.activeTime),
                    "yyyy-MM-dd hh:mm"
                  )}生效）`;
                }
                return {
                  label: showLabel,
                  value: item.priceChangeRuleId,
                };
              });
              this.discountListsKids = (kids || []).map((item) => {
                let showLabel = item.seasonCode;
                if (item.coFlag === 1) {
                  showLabel += "(CO)";
                }
                if (status === 1) {
                  showLabel += `（${utils.dateFormat(
                    new Date(item.activeTime),
                    "yyyy-MM-dd hh:mm"
                  )}生效）`;
                }
                return {
                  label: showLabel,
                  value: item.priceChangeRuleId,
                };
              });
            }
            this.selectVendorList = this.vendorLists.map(
              (item) => item.vendorId
            );
            this.selectDiscountListAdult = this.discountListsAdult.map(
              (item) => item.value
            );
            this.selectDiscountListKids = this.discountListsKids.map(
              (item) => item.value
            );
            this.dialogDiscountStatus = status;
            this.dialogVisible = true;
            this.ruleForm2.validFrom = null;
            this.ruleForm2.nextValidDate = null;
            if (this.dialogDiscountStatus == 1) {
              this.ruleForm2.nextValidDateType = "2";
              this.ruleForm2.validFromType = "2";
            } else if (this.dialogDiscountStatus == 2) {
              this.ruleForm2.nextValidDateType = "0";
              this.ruleForm2.validFromType = "0";
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("请求异常");
          });
      } catch (error) {
        console.log(error);
        this.$message.error(`${error}`);
      }
    },
    selectAllSeason() {
      this.selectDiscountListAdult = this.discountListsAdult.map(
        (item) => item.value
      );
      this.selectDiscountListKids = this.discountListsKids.map(
        (item) => item.value
      );
    },
    handleClose() {
      this.$refs["ruleForm2"].resetFields();
      this.dialogVisible = false;
    },
    setting(data) {
      const { vendorId, vendorName, co, supplyPriceMethod } = data;
      let routeData = this.$router.resolve({
        path: "/discount/cn/daily/vendor",
        query: {
          id: vendorId,
          name: vendorName,
          co,
          supplyPriceMethod
        },
      });
      window.open(routeData.href, "_blank");
    },
    confirm() {
      if (!this.selectVendorList.length) {
        this.$message.error("请选择至少一个买手店");
        return;
      }
      const selectedDiscount = this.selectDiscountListAdult.concat(
        this.selectDiscountListKids
      );
      console.log(this.selectVendorList, selectedDiscount);
      if (!selectedDiscount.length) {
        this.$message.error("请选择至少一个季节");
        return;
      }
      this.$refs["ruleForm2"].validate(async (valid) => {
        if (valid) {
          let startAt = (new Date(this.ruleForm2.validFrom) * 1000) / 1000;
          if (this.ruleForm2.validFromType == 0) {
            if (!startAt) {
              this.$message.error("请选择生效时间");
              return;
            }
            if (startAt < Date.now()) {
              this.$message.error("当前生效时间已过期，请重新选择生效时间");
              return;
            }
          }

          if (this.ruleForm2.nextValidDateType == 0) {
            if (!this.ruleForm2.nextValidDate) {
              this.$message.error("请选择失效时间");
              return;
            }
            if (this.ruleForm2.nextValidDate) {
              var nextValidDate =
                (new Date(this.ruleForm2.nextValidDate) * 1000) / 1000;
              var minDate =
                this.ruleForm2.validFromType == 0
                  ? (new Date(this.ruleForm2.validFrom) * 1000) / 1000
                  : Date.now();
              if (nextValidDate < minDate + 1 * 24 * 3600 * 1000) {
                this.$message.error("失效时间必须晚于生效时间至少一天");
                return;
              }
            }
          }
          var resData = await priceChangeRuleCopyCheck({
            validFromType: +this.ruleForm2.validFromType,
            validFrom: this.ruleForm2.validFromType == 0 ? startAt : 0,
            vendorIds: this.selectVendorList,
            priceChangeRuleIds: selectedDiscount,
            nextValidDateType: +this.ruleForm2.nextValidDateType,
            nextValidDate:
              this.ruleForm2.nextValidDateType == 0
                ? (new Date(this.ruleForm2.nextValidDate) * 1000) / 1000
                : null,
          });
          if (resData.success) {
          } else if (
            resData.code == 2001 &&
            resData.data &&
            resData.data.length
          ) {
            let errorMessage =
              "<p>以下店铺中含有部分季节无生效中折扣，无法提交</p>";
            resData.data.map((item) => {
              let category =
                item.categoryType == 1
                  ? "Adult -"
                  : item.categoryType == 2
                  ? "Kids -"
                  : "";
              let coFlagStr =
                item.coFlag == 1
                  ? "(CO)"
                  : "";

              errorMessage += `<p style="padding:6px 0"> ${item.vendorName} - ${category}${item.seasonCode}${coFlagStr}  </p>`;
            });
            this.$message({
              dangerouslyUseHTMLString: true,
              type: "error",
              message: errorMessage,
            });
            return;
          } else {
            this.$message.error(resData.message || "请求异常");
            return;
          }
          this.$confirm("是否确认复制?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(async () => {
              this.$store.commit("setPageLoading", true);
              let resData = await priceChangeRuleCopy({
                validFromType: +this.ruleForm2.validFromType,
                validFrom: this.ruleForm2.validFromType == 0 ? startAt : 0,
                vendorIds: this.selectVendorList,
                priceChangeRuleIds: selectedDiscount,
                nextValidDateType: +this.ruleForm2.nextValidDateType,
                nextValidDate:
                  this.ruleForm2.nextValidDateType == 0
                    ? (new Date(this.ruleForm2.nextValidDate) * 1000) / 1000
                    : null,
              });
              this.$store.commit("setPageLoading", false);
              if (resData.success) {
                this.$message.success("复制成功");
                this.dialogVisible = false;
                this.selectDiscountListAdult = [];
                this.selectDiscountListKids = [];
                this.selectVendorList = [];
              } else if (
                resData.code == 2001 &&
                resData.data &&
                resData.data.length
              ) {
                let errorMessage =
                  "<p>以下店铺中含有部分季节无生效中折扣，无法提交</p>";
                resData.data.map((item) => {
                  errorMessage += `<p style="padding:6px 0"> ${item.vendorName} - ${item.seasonCode}  </p>`;
                });
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "error",
                  message: errorMessage,
                });
              } else {
                this.$message.error(resData.message || "请求异常");
              }
            })
            .catch((error) => {
              this.$message.error(`${error}`);
            });
        }
      });
    },
    resetForm() {
      this.form = {};
      this.currentPage = 1;
      this.pageSize = 15;
      this.getTableData();
    },
    async getTableData() {
      let targetObj = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        vendorId: this.form.vendorId,
      };
      this.$store.commit("setPageLoading", true);
      let resData = await getDiscountVendorList(targetObj);
      this.$store.commit("setPageLoading", false);
      if (!resData.data) {
        this.$message.error(`${resData.message}`);
        return;
      }
      let { total, list } = resData.data;
      this.total = total;
      list.forEach((item) => {
        item.visible = false;
      });
      this.tableData = list;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
  },
};
</script>
<style lang="less" scoped>
.dialogContainer .el-checkbox {
  margin-left: 0;
  margin-right: 20px;
  margin-bottom: 5px;
}
.manipulate {
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;
}
.dot {
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.gray {
  background: #cccccc;
}
.green {
  background: green;
}
.dropdown-item {
  margin: 0;
  padding: 7px 16px;
  clear: both;
  color: #657180;
  font-size: 12px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.demo-ruleForm {
  margin: 20px 0px;
}
.flex {
  height: 80px;
  padding-top: 13px;
  padding-left: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}
.absolute {
  position: absolute;
  top: 0;
  left: 168px;
}
</style>
